// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-DataExtraction-DataExtractionTemplate-components-Modals-Modal-module__ModalBodyText";
export { _1 as "ModalBodyText" }
